<script setup lang="ts">
/** Aventross AGM (Audited) — 원본 합본 문서 4부((Incorporated In Singapore)). gen_vue 로 템플릿 글자 그대로 생성. */
import CddVarField from '../../../aura/agm/cdd/CddVarField.vue';
import DocScope from '../../../aura/agm/cdd/DocScope.vue';
import AgmSigners from '../../../aura/agm/cdd/AgmSigners.vue';
import { useRepeat } from '../useRepeat';
import '../../../aura/agm/docs/agmDoc.css';
import '../avDoc.css';

const R = useRepeat();
void CddVarField; void DocScope; void AgmSigners;
</script>

<template>
  <div class="agm-doc av-doc">
    <div class="gap" />
    <p class="doc-p center bold"><CddVarField field-key="company_name" label="Company Name" /></p>
    <p class="doc-p center">(Incorporated In Singapore)</p>
    <p class="doc-p center">Company Registration No. <CddVarField field-key="company_registration_no" label="Company Registration No." /></p>
    <div class="gap" />
    <p class="doc-p center bold">MINUTES OF ANNUAL GENERAL MEETING</p>
    <div class="gap" />
    <p class="doc-p">MINUTES of the Annual General Meeting of the members of the Company duly convened and held on:-</p>
    <div class="gap" />
    <p class="doc-p">Date: <CddVarField field-key="agm_date" label="AGM date" /></p>
    <p class="doc-p">Time: 10:00 am</p>
    <p class="doc-p">Venue: <CddVarField field-key="agm_venue" label="AGM venue" /></p>
    <p class="doc-p">Present: As per Attendance List</p>
    <p class="doc-p">Chairman: <CddVarField field-key="chairman_name" label="Chairman" /> was appointed Chairman of the meeting.</p>
    <p class="doc-p">Notice of Meeting: The notice calling for the meeting was taken as read.</p>
    <p class="doc-p">_____________________________________________________________________________________</p>
    <div class="gap" />
    <p class="doc-p bold">AUDITED FINANCIAL STATEMENTS AND DIRECTORS’ STATEMENTS</p>
    <div class="gap" />
    <p class="doc-p">Resolved that the audited financial statements of the Company for the financial year ended <CddVarField field-key="financial_year_end" label="FYE" /> together with the directors' statement thereon be approved and that the said directors' statement be signed by directors of the Company.</p>
    <div class="gap" />
    <p class="doc-p bold">RE-ELECTION OF DIRECTORS</p>
    <div class="gap" />
    <p class="doc-p">Resolved that <CddVarField field-key="reelected_directors" label="Re-elected directors (e.g. A, B and C)" /> be hereby re-elected as Directors of Company</p>
    <div class="gap" />
    <p class="doc-p bold">DIRECTORS’ REMUNERATION</p>
    <div class="gap" />
    <p class="doc-p">Resolved that Directors’ Remuneration and/or Benefit-in-kind (if any) as shown in the audited Financial Statements for the year ended <CddVarField field-key="financial_year_end" label="FYE" /> and paid to Director(s) be and is/are hereby approved.</p>
    <div class="gap" />
    <p class="doc-p">&emsp;Resolved that Directors’ Remuneration of S$<CddVarField field-key="directors_remuneration_amount" label="Remuneration amount (e.g. 120,000)" /> paid to the following Directors as shown in the trading, profit and loss account for the financial year ended <CddVarField field-key="financial_year_end" label="FYE" /> be hereby approved: -</p>
    <div class="gap" />
    <p class="doc-p bold">DIRECTORS’ FEES</p>
    <div class="gap" />
    <p class="doc-p">Resolved that Directors’ Fees of <CddVarField field-key="directors_fees" label="Directors’ fees" /> for financial year end <CddVarField field-key="financial_year_end" label="FYE" />, as stated in the financial statements be and is hereby approved at the forthcoming Annual General Meeting.</p>
    <div class="gap" />
    <p class="doc-p bold">INTERIM/FINAL DIVIDEND</p>
    <div class="gap" />
    <p class="doc-p">Resolved that a final one-tier tax exempt dividend of <CddVarField field-key="final_dividend" label="Final dividend per share" /> per ordinary share for the financial year ended <CddVarField field-key="financial_year_end" label="FYE" /> is hereby approved at the forthcoming Annual General Meeting.</p>
    <div class="gap" />
    <p class="doc-p bold">RELATED PARTY TRANSACTIONS</p>
    <div class="gap" />
    <p class="doc-p">RESOLVED that the following related party transactions for the financial year ended <CddVarField field-key="financial_year_end" label="FYE" /> be and are hereby approved:</p>
    <div class="gap" />
    <p class="doc-p bold">RE-APPOINTMENT OF AUDITORS</p>
    <div class="gap" />
    <p class="doc-p">Resolved that <CddVarField field-key="auditor_name" label="Auditor" /> (UEN: <CddVarField field-key="auditor_uen" label="Auditor UEN" />) as the Company’s Auditor be and is hereby approved to be re-appointed at the forthcoming Annual General Meeting.</p>
    <div class="gap" />
    <p class="doc-p bold">AUTHORITY TO E-FILE RETURNS</p>
    <div class="gap" />
    <p class="doc-p">Resolved that any officer of the Company or such other person(s) as directed by the directors be authorised to e-file the relevant returns relating thereto with the Accounting and Corporate Regulatory Authority, for and on behalf of the Company. </p>
    <div class="gap" />
    <p class="doc-p bold">OTHER MATTERS</p>
    <div class="gap" />
    <p class="doc-p">Pursuant to Section 199(2) of the Companies Act 1967, the board of directors confirmed that the accounting and other records have been kept in the company office not less than 5 years.</p>
    <div class="gap" />
    <p class="doc-p">Date: <CddVarField field-key="minutes_signed_date" label="Minutes signed date" /></p>
    <div class="gap" />
    <p class="doc-p">Signed as a correct record,</p>
    <div class="gap" />
    <p class="doc-p">___________________&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;___________________&emsp;&emsp;</p>
    <p class="doc-p"><CddVarField field-key="chairman_name" label="Chairman" />&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;<CddVarField field-key="minutes_director_name" label="Director (minutes)" /></p>
    <p class="doc-p">Chairman&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;Director</p>
    <div class="gap" />
  </div>
</template>
